export const PUBLIC_FIRM_CREDENTIALS = {
  inspections: 'Inspections',
  clearanceTesting: 'Clearance Testing',
  leadHazardScreening: 'Lead Hazard Screening',
  riskAssessments: 'Risk Assessments',
  abatement: 'Abatement',
};

export const PUBLIC_FIRM_CREDENTIAL_MAPPING: Record<string, string[]> = {
  Inspections: ['Inspector', 'Risk Assessor'],
  'Clearance Testing': ['Inspector', 'Risk Assessor'],
  'Lead Hazard Screening': ['Risk Assessor'],
  'Risk Assessments': ['Risk Assessor'],
  Abatement: ['Supervisor'],
};

export const PUBLIC_FIRM_CONTACT_TYPES = {
  office: 'Office',
  personal: 'Personal',
  satellite: 'Satellite',
  work: 'Work',
  representative: 'Representative',
};

export const PUBLIC_FIRM_ADDRESS_TYPES = {
  physical: 'Physical',
  mailing: 'Mailing',
  satellite: 'Satellite',
  work: 'Work',
  residence: 'Residence',
};
